import { pushDataLayer } from './items';
import { getLocalStorage } from '../../01-helpers/session-manager';

const moduleName = 'datalayer',
    selector = {
        base: `.js-${moduleName}`
    };

export class DataLayer {
    constructor(element) {
        this.element = element;
        this.event = this.element.dataset.dlevent
        this.customField = JSON.parse(this.element.dataset.dlcustomfield) || null;
        this.receiptData = getLocalStorage('TeeTime');
		this._setup();
	}

    _setup() {
        const items = [{
            item_name: this.receiptData.CourseName,
            item_id: this.receiptData.CourseNumber,
            price: this.receiptData?.Fee,
            item_brand: 'Golfgo',
            item_category: this.receiptData.Time,  //fill this variable with the chosen timeslot
            item_category2: this.receiptData.Date,   //fill this variable with the chosen date
            item_category3: this.receiptData.Holes,   //fill this variable with the chosen amount of holes
            item_category4: this.receiptData.Players,    //fill this with the amount of players
            item_variant: "",
            quantity: '1'
        }];

        pushDataLayer(this.event, items, this.customField);
    }
}

function initDataLayer() {
    document.querySelectorAll(selector.base).forEach((element) => {
        new DataLayer(element);
    });
}

initDataLayer();